<script setup lang="ts">
  import { fmt } from '@/functions'
  import SearchResultGroup from './search-result-group.vue'

  defineProps<{
    users: SearchUser[],
  }>()
</script>

<template>
  <search-result-group
    v-slot="{ item: user }"
    :name="'Pelanggan'"
    :route-list="'customer list'"
    :items="users">
    <div class="flex items-center gap-x-2">
      <div>
        <div class="text-sm">
          <span class="font-medium">
            {{ user.name }}
          </span>
          <span
            v-if="user.username"
            class="italic">
            ({{ user.username }})
          </span>
        </div>
        <div
          v-if="user.role"
          class="mb-1 text-xs text-gray-500">
          {{ user.role.name }}
        </div>
        <div
          v-if="user.created_at"
          class="text-xs text-gray-500">
          Dibuat: {{ fmt.date(user.created_at) }}
        </div>
      </div>
    </div>
  </search-result-group>
</template>
